export const PROJECT_TYPES = [
  { value: "business_attraction", label: "Business Attraction" },
  {
    value: "business_retention_expansion",
    label: "Business Retention & Expansion",
  },
  { value: "Startup", label: "Startup" },
];
